import React from 'react';

interface BrightforgeMarkProps {
  className?: string;
  tileClassName?: string;
  glyphClassName?: string;
  outlineClassName?: string;
}

const BrightforgeMark: React.FC<BrightforgeMarkProps> = ({
  className = '',
  tileClassName = 'bg-white/95',
  glyphClassName = 'text-[#1f1f1f]',
  outlineClassName = 'border-secondary/20 shadow-[0_0_30px_rgba(0,255,157,0.08)]',
}) => {
  return (
    <div className={`relative ${className}`} aria-hidden="true">
      <div className={`absolute inset-0 rounded-[18px] border ${outlineClassName}`} />
      <div className={`relative flex h-full w-full items-center justify-center rounded-[16px] ${tileClassName}`}>
        <svg
          viewBox="0 0 140 108"
          className={`h-[72%] w-[72%] ${glyphClassName}`}
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="4" y="6" width="44" height="44" />
          <path d="M92 6a44 44 0 0 1-44 44V6h44Z" />
          <path d="M92 50A44 44 0 0 1 136 6v44H92Z" />
          <path d="M4 94a44 44 0 0 1 44-44v44H4Z" />
          <rect x="48" y="50" width="44" height="44" />
          <rect x="92" y="50" width="44" height="44" />
          <circle cx="134" cy="101" r="6" />
        </svg>
      </div>
    </div>
  );
};

export default BrightforgeMark;
